import { SPACE, THEME } from '../../../web/components-v2/Theme/theme';
import { shadowSm } from '../../../web/styles/shadows';
import { FontFamilies } from '../../../web/styles/styles';
import { aidaBaseStyles } from '../../styles/styles';
import { StyleSheet } from 'aphrodite';

const { fontFamilies, fontSizes, fontWeights } = THEME.typography;

export const styleSheet = StyleSheet.create({
	basicPageContainer: {
		...aidaBaseStyles.flexCol,
		height: 'auto',
		margin: '0 auto',
		maxWidth: 1400,
		minHeight: '95%',
		paddingTop: 20,
	},
	body: {
		minWidth: '100%',
	},
	header: {
		...aidaBaseStyles.flexCenter,
		marginTop: SPACE[12],
		minWidth: '100%',
		position: 'relative',
		[THEME.queries.md]: {
			flexDirection: 'column',
			gap: SPACE[8],
		},
	},
	headerActions: {
		position: 'absolute',
		right: 0,
		top: '50%',
		transform: 'translateY(-50%)',
		[THEME.queries.md]: {
			position: 'static',
			transform: 'none',
		},
	},
	lightCard: {
		backgroundColor: THEME.colors.background.light,
		borderRadius: THEME.common.borderRadius,
		boxShadow: shadowSm,
		boxSizing: 'border-box',
		padding: SPACE[32],
		[THEME.queries.sm]: {
			padding: SPACE[16],
		},
	},
	lightCardFlat: {
		borderRadius: 0,
		boxShadow: 'none',
		padding: 0,
		[THEME.queries.sm]: {
			padding: 0,
		},
	},
	lightCardFill: {
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		minHeight: 0,
		[THEME.queries.md]: {
			flex: 'none',
		},
	},
	lightBodyFill: {
		display: 'flex',
		flex: 1,
		flexDirection: 'column',
		minHeight: 0,
		[THEME.queries.md]: {
			flex: 'none',
		},
	},
	lightHeader: {
		alignItems: 'flex-start',
		display: 'flex',
		flexWrap: 'wrap',
		gap: SPACE[16],
		justifyContent: 'space-between',
		marginBottom: SPACE[24],
	},
	lightHeading: {
		display: 'flex',
		flexDirection: 'column',
		gap: SPACE[4],
	},
	lightTitleRow: {
		alignItems: 'center',
		display: 'flex',
		gap: SPACE[4],
	},
	lightHeaderActions: {
		alignItems: 'center',
		display: 'flex',
		gap: SPACE[12],
	},
	// Same box as the Call log and Settings home pages, so the titles line up across Coffee.
	lightPage: {
		boxSizing: 'border-box',
		color: THEME.colors.text.main,
		fontFamily: fontFamilies.lexend,
		margin: '0 auto',
		maxWidth: 1400,
		padding: SPACE[16],
		width: '100%',
	},
	// Full-white page: left-aligned so titles land at the same x with or without the drawer rail, and the 48px padding
	// equals the card layout's 16px page + 32px card padding.
	lightPageWhite: {
		margin: 0,
		padding: `${SPACE[48]}px ${SPACE[48]}px ${SPACE[32]}px`,
		[THEME.queries.md]: {
			padding: SPACE[16],
		},
	},
	// Fills the scrolling body edge to edge, covering the blue. Inside a flex scroller it would otherwise be stretched or
	// shrunk to the visible height and let a tall page run past the white.
	lightBackdrop: {
		alignSelf: 'flex-start',
		backgroundColor: THEME.colors.background.light,
		flexShrink: 0,
		minHeight: '100%',
		width: '100%',
	},
	lightBackdropFill: {
		alignSelf: 'stretch',
		height: '100%',
		[THEME.queries.md]: {
			height: 'auto',
		},
	},
	lightPageFill: {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
		[THEME.queries.md]: {
			height: 'auto',
		},
	},
	lightSubtitle: {
		color: THEME.colors.text.light,
		fontSize: fontSizes.sm,
		margin: 0,
	},
	lightTitle: {
		color: THEME.colors.text.main,
		fontFamily: fontFamilies.sora,
		fontSize: fontSizes.xl,
		fontWeight: fontWeights.bold,
		margin: 0,
	},
	title: {
		color: '#fff',
		fontFamily: FontFamilies.conqueror,
		fontSize: 54,
		textTransform: 'uppercase',
	},
});
